export type CompetitionStatus = "upcoming" | "live" | "completed";

export type Competition = {
  id: string;
  name: string;
  tour: string;
  location: string;
  country: string;
  startDate: string; // ISO
  endDate: string;   // ISO
  break: string;
};

/**
 * Automatically calculates competition status based on today's date.
 */
export const getStatus = (startDate: string, endDate: string): CompetitionStatus => {
  const now = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);
  end.setHours(23, 59, 59, 999);
  if (now >= start && now <= end) return "live";
  if (now > end) return "completed";
  return "upcoming";
};

// ─── 2026 WSL CHAMPIONSHIP TOUR — Full official schedule ────────────────────
// Source: worldsurfleague.com / wikipedia.org/wiki/2026_World_Surf_League
// Last verified: May 29 2026
// Events 1–4 completed. Event 5 (El Salvador) is next: Jun 5–15.

export const competitions: Competition[] = [
  // ── REGULAR SEASON (Events 1–9) ──────────────────────────────────────────
  {
    id: "bells-2026",
    name: "Rip Curl Pro Bells Beach",
    tour: "WSL Championship Tour",
    location: "Bells Beach, Victoria",
    country: "Australia",
    startDate: "2026-04-01",
    endDate: "2026-04-11",
    break: "Bells Beach",
  },
  {
    id: "margaret-2026",
    name: "Western Australia Margaret River Pro",
    tour: "WSL Championship Tour",
    location: "Main Break, Margaret River",
    country: "Australia",
    startDate: "2026-04-17",
    endDate: "2026-04-27",
    break: "Margaret River",
  },
  {
    id: "goldcoast-2026",
    name: "Bonsoy Gold Coast Pro",
    tour: "WSL Championship Tour",
    location: "Snapper Rocks, Gold Coast",
    country: "Australia",
    startDate: "2026-05-02",
    endDate: "2026-05-12",
    break: "Snapper Rocks",
  },
  {
    id: "newzealand-2026",
    name: "Corona Cero New Zealand Pro",
    tour: "WSL Championship Tour",
    location: "Manu Bay, Raglan",
    country: "New Zealand",
    startDate: "2026-05-15",
    endDate: "2026-05-25",
    break: "Manu Bay",
  },
  {
    id: "elsalvador-2026",
    name: "Surf City El Salvador Pro",
    tour: "WSL Championship Tour",
    location: "Punta Roca, La Libertad",
    country: "El Salvador",
    startDate: "2026-06-05",
    endDate: "2026-06-15",
    break: "Punta Roca",
  },
  {
    id: "rio-2026",
    name: "VIVO Rio Pro",
    tour: "WSL Championship Tour",
    location: "Itaúna Beach, Saquarema",
    country: "Brazil",
    startDate: "2026-06-19",
    endDate: "2026-06-27",
    break: "Saquarema",
  },
  {
    id: "tahiti-2026",
    name: "Lexus Tahiti Pro",
    tour: "WSL Championship Tour",
    location: "Teahupo'o",
    country: "French Polynesia",
    startDate: "2026-08-08",
    endDate: "2026-08-18",
    break: "Teahupo'o",
  },
  {
    id: "fiji-2026",
    name: "Corona Fiji Pro",
    tour: "WSL Championship Tour",
    location: "Cloudbreak, Tavarua",
    country: "Fiji",
    startDate: "2026-08-25",
    endDate: "2026-09-04",
    break: "Cloudbreak",
  },
  {
    id: "trestles-2026",
    name: "Lexus Trestles Pro",
    tour: "WSL Championship Tour",
    location: "Lower Trestles, San Clemente",
    country: "California, USA",
    startDate: "2026-09-11",
    endDate: "2026-09-20",
    break: "Lower Trestles",
  },
  // ── POSTSEASON (Events 10–11, field cut to top 24 men / 16 women) ─────────
  {
    id: "abudhabi-2026",
    name: "Surf Abu Dhabi Pro",
    tour: "WSL Championship Tour — Postseason",
    location: "Hudayriat Island",
    country: "UAE",
    startDate: "2026-10-14",
    endDate: "2026-10-18",
    break: "Hudayriat Island",
  },
  {
    id: "portugal-2026",
    name: "MEO Rip Curl Pro Portugal",
    tour: "WSL Championship Tour — Postseason",
    location: "Supertubos, Peniche",
    country: "Portugal",
    startDate: "2026-10-22",
    endDate: "2026-11-01",
    break: "Supertubos",
  },
  // ── SEASON FINALE — World title decided here ──────────────────────────────
  {
    id: "pipe-2026",
    name: "Lexus Pipe Pro",
    tour: "WSL Championship Tour — Season Finale",
    location: "Banzai Pipeline, Oahu",
    country: "Hawaii, USA",
    startDate: "2026-12-08",
    endDate: "2026-12-20",
    break: "Pipeline",
  },
];

export const competitionsWithStatus = competitions.map((comp) => ({
  ...comp,
  status: getStatus(comp.startDate, comp.endDate),
}));
